import { render, staticRenderFns } from "./OrderDiscountsList.vue?vue&type=template&id=7938a38c&scoped=true&"
import script from "./OrderDiscountsList.vue?vue&type=script&lang=js&"
export * from "./OrderDiscountsList.vue?vue&type=script&lang=js&"
import style0 from "./OrderDiscountsList.vue?vue&type=style&index=0&id=7938a38c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7938a38c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
